import React, { forwardRef, useRef } from 'react';
import Modal from '../../../../../core/components/Modal';
import { assignRefs, printToast } from '../../../../../core/utils/Global';
import BaseForm from '../../../../../core/page/components/baseForm/BaseForm';
import styles from './ModalJustificativa.module.scss';
import InputTypes from '../../../../../core/enums/InputTypes';
import InputField from '../../../../../components/inputField/InputField';
import { InputTextarea } from 'primereact/inputtextarea';
import InputTextLengthCounter from '../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';
import { Button } from 'primereact/button';
import PropostaIndicadorService from '../../../../../service/PropostaIndicadorService';
import Pages from '../../../../../config/Pages';
import { errosTratados } from '../../../../../config/Axios';
import Shareds from '../../../../../config/translations/Shareds';

const inputs = [
    {
        name: 'idProposta',
        label: 'ID Proposta',
        type: InputTypes.INTEGER,
        form: { use: true },
    },
    {
        name: 'motivo',
        label: 'Motivo',
        type: InputTypes.STRING,
        form: { use: true, initialValue: '', validate: { required: true, max: 150 } },
    },
    {
        name: 'isView',
        label: '',
        type: InputTypes.BOOLEAN,
        form: { use: true, initialValue: false },
    },
];

function ModalJustificativa({ onSave, ...props }, ref) {
    const modalRef = useRef(null);

    const Inputs = ({ formik, formController }) => (
        <form onSubmit={formik.handleSubmit} className={`p-col-12 p-grid p-fluid ${styles.form}`}>
            <InputField id="motivo" formik={formik} formController={formController}>
                <InputTextLengthCounter maxLen={150}>
                    <InputTextarea
                        name="motivo"
                        value={formik.values.motivo}
                        onChange={formik.handleChange}
                        disabled={formik.values.isView}
                    />
                </InputTextLengthCounter>
            </InputField>
            <div className="buttonsRight">
                <Button
                    label="Cancelar"
                    className="p-button-secondary"
                    type="button"
                    icon="pi pi-arrow-left"
                    onClick={() => modalRef.current?.hide()}
                />
                {!formik.values.isView && (
                    <Button
                        label="Confirmar cancelamento"
                        className="p-button-info"
                        type="submit"
                        icon="pi pi-check"
                        onClick={() => formController.addCountClick()}
                    />
                )}
            </div>
        </form>
    );

    const ModalBody = ({ modalData }) => {
        const { id, situacaoProposta, descMotivoCancelamento = '' } = modalData;

        return (
            <BaseForm
                showToast={false}
                redirectOnSave={false}
                buscarOnLoad={false}
                actionOnSave={(dados) => onSave(dados)}
                onSubmit={async ({ registro }) => {
                    try {
                        await PropostaIndicadorService.cancelarProposta({
                            ...registro,
                            idProposta: id,
                        });
                        printToast({
                            severity: 'success',
                            summary: Pages.sei.indicador.title,
                            detail: Shareds.form.successCancelar,
                        });
                    } catch (error) {
                        if (!errosTratados.includes(error.response?.status)) {
                            printToast({
                                severity: 'error',
                                summary: Pages.sei.indicador.title,
                                detail: error.response?.message,
                            });
                        }
                    }
                }}
                initialValues={inputs.filter((input) => input?.form?.use ?? false)}
                prepareInitialValues={(data) => ({
                    ...data,
                    idProposta: id,
                    motivo: descMotivoCancelamento ?? '',
                    isView: situacaoProposta?.codgSituacaoProposta === 'CANCELADA' ? true : false,
                })}
            >
                <Inputs />
            </BaseForm>
        );
    };

    return (
        <Modal
            header={
                <>
                    <i className={`pi pi-ban ${styles.iconHeader}`} />
                    Cancelar Proposta
                </>
            }
            style={{ width: '60vw' }}
            widthOnMobile={700}
            onMobile={(styles) => ({ ...styles, maxWidth: '100vw', height: '100%' })}
            ref={assignRefs(ref, modalRef)}
            {...props}
        >
            <ModalBody />
        </Modal>
    );
}

export default forwardRef(ModalJustificativa);
